import React from 'react'
import ProjectAccessGuard from '../ProjectAccessGuard'
import Users from '../Users'

const ProjectAccessUsers = () => (
  <ProjectAccessGuard>
    {projectId => <Users projectId={projectId} hideNav canManageMembers />}
  </ProjectAccessGuard>
)

export default ProjectAccessUsers
